import { createContext } from 'react';

const TokensContext = createContext(null);

export default TokensContext;

